import { createGlobalStyle } from 'styled-components';
import { pulsingDotsAnimationAfter, pulsingDotsAnimationBefore, pulsingDotsAnimationMiddle } from '../common/store/theme/constants/pulsing-dots-animation';

export const GlobalStyles = createGlobalStyle`
  * {
    box-sizing: border-box;
  }
  ${pulsingDotsAnimationBefore};
  ${pulsingDotsAnimationAfter};
  ${pulsingDotsAnimationMiddle};
`;